import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor
{
    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: any
    )
    {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        if (!request.url.startsWith('/api') && !request.url.startsWith('/auth')) return next.handle(request);

        const clonedReq = request.clone({
            url: request.url.includes(environment.api_host) ? request.url : environment.api_host + request.url,
            withCredentials: true
        });

        return next.handle(clonedReq);
    }
}
